import {
  createAsyncThunk,
  createSelector,
  createSlice,
  current,
} from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/sif/tipPripusta";

/**
 * GET /api/sif/tipPripusta
 */
export const fetchMatingTypeCodeList = createAsyncThunk(
  "matingTypeCodeLists/fetchAll",
  async (_, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(baseUrl);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

/**
 * GET /api/sif/tipPripusta/{sifra}
 */
export const fetchMatingTypeCodeBySifra = createAsyncThunk(
  "matingTypeCodeLists/fetchBySifra",
  async (sifra, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(`${baseUrl}/${sifra}`);
      return response?.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

/**
 * GET /api/sif/tipPripusta/page
 */
export const fetchMatingTypeCodePage = createAsyncThunk(
  "matingTypeCodeLists/fetchPage",
  async ({ page, filter, sort } = {}, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        undefined,
        page,
        filter,
        sort,
        true
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

/**
 * POST /api/sif/tipPripusta
 */
export const createMatingTypeCode = createAsyncThunk(
  "matingTypeCodeLists/create",
  async (payload, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.post(baseUrl, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

/**
 * PUT /api/sif/tipPripusta/{sifra}
 */
export const updateMatingTypeCode = createAsyncThunk(
  "matingTypeCodeLists/update",
  async ({ sifra, data }, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.put(`${baseUrl}/${sifra}`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

/**
 * DELETE /api/sif/tipPripusta/{sifra}
 */
export const deleteMatingTypeCode = createAsyncThunk(
  "matingTypeCodeLists/delete",
  async (sifra, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      await ApiClient.delete(`${baseUrl}/${sifra}`);
      return sifra;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const matingTypeCodeListSlice = createSlice({
  name: "matingTypeCodeLists",
  initialState: {
    list: [],
    page: {},

    error: null,
    isLoading: false,
    details: null,

    byId: {},
    isLoadingById: {},
    errorById: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    // ---- LIST (ALL) ----
    builder.addCase(fetchMatingTypeCodeList.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(fetchMatingTypeCodeList.fulfilled, (state, action) => {
      state.list = action.payload;
      state.isLoading = false;
      if (action.payload != null) {
        for (const item of action.payload) {
          if (item?.sifra) {
            state.byId[item.sifra] = item;
          }
        }
      }
    });
    builder
      .addCase(fetchMatingTypeCodeList.rejected, (state, action) => {
        state.error = action.payload;
        state.isLoading = false;
      })

      // ---- SINGLE BY SIFRA ----
      .addCase(fetchMatingTypeCodeBySifra.pending, (state, action) => {
        const sifra = action.meta.arg;

        if (!state.errorById) {
          state.errorById = {};
        }
        if (!state.isLoadingById) {
          state.isLoadingById = {};
        }
        if (!state.byId) {
          state.byId = {};
        }
        state.isLoadingById[sifra] = "";
        state.isLoadingById[sifra] = true;
        state.isLoading = true;
      })
      .addCase(fetchMatingTypeCodeBySifra.fulfilled, (state, action) => {
        const item = action.payload;
        if (item) {
          state.errorById[item.sifra] = "";
          state.byId[item.sifra] = item;
          state.isLoadingById[item.sifra] = false;
        }
        state.error = null;
        state.details = item;
        state.isLoading = false;
        console.log(current(state));
      })
      .addCase(fetchMatingTypeCodeBySifra.rejected, (state, action) => {
        const sifra = action.meta.arg;
        state.errorById[sifra] = action.payload;
        state.isLoadingById[sifra] = false;
      });

    // ---- PAGE ----
    builder.addCase(fetchMatingTypeCodePage.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(fetchMatingTypeCodePage.fulfilled, (state, action) => {
      state.isLoading = false;
      state.page = action.payload;

      const content = action.payload?.content || [];
      state.list = content;
    });
    builder.addCase(fetchMatingTypeCodePage.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });

    // ---- CREATE ----
    builder.addCase(createMatingTypeCode.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(createMatingTypeCode.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(createMatingTypeCode.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });

    // ---- UPDATE ----
    builder.addCase(updateMatingTypeCode.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(updateMatingTypeCode.fulfilled, (state, action) => {
      state.isLoading = false;
      const item = action.payload.output;
      if (item?.sifra) {
        const idx = state.list.findIndex((s) => s.sifra === item.sifra);
        if (idx !== -1) {
          state.list[idx] = item;
        }
        state.details = item.sifra;
      }
    });
    builder.addCase(updateMatingTypeCode.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });

    // ---- DELETE ----
    builder.addCase(deleteMatingTypeCode.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(deleteMatingTypeCode.fulfilled, (state, action) => {
      state.isLoading = false;
      const sifra = action.payload;
      delete state.byId[sifra];
      state.list = state.list.filter((item) => item.sifra !== sifra);
      if (state.details === sifra) {
        state.details = null;
      }
    });
    builder.addCase(deleteMatingTypeCode.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default matingTypeCodeListSlice.reducer;

export const MATING_TYPE_CODE_LIST = createSelector(
  (state) => state.matingTypeCodeList,
  ({ list }) =>
    list.filter(
      ({ sifra, veljaZaKoze, veljaZaOvce }) =>
        veljaZaKoze && veljaZaOvce && !!sifra
    )
);
